const ITEM_AUTH_TOKEN = 'AuthToken'

const TokenStorage = {
  storeAuthToken: function (token) {
    localStorage.setItem(ITEM_AUTH_TOKEN, token);
  },
  loadAuthToken: function () {
    let token = localStorage.getItem(ITEM_AUTH_TOKEN)
    return token;
  },
  removeAuthToken: function () {
    localStorage.removeItem(ITEM_AUTH_TOKEN)
  }
}

export default TokenStorage
